export enum Geschlecht {
    männlich = 1,
    weiblich = 2,
}

export enum Jahr {
    y2010 = 805290000,
    y2011 = 805290001,
    y2012 = 805290002,
    y2013 = 805290003,
    y2014 = 805290004,
    y2015 = 805290005,
    y2016 = 805290006,
    y2017 = 805290007,
    y2018 = 805290008,
    y2019 = 805290009,
    y2020 = 805290010
}

export enum Status {
    Alle = "null",
    Offen = 805290000,
    Abgeschlossen = 805290005,
    Abgelehnt = 805290003,
    // Storniert = 805290002,    
    // Ausgebucht = 805290001,
    // Teilabgerechnet = 805290004,
    // ZurBewilligungLFW = 805290006,
    // InBearbeitungLFW = 805290008,
    // BearbeitungLFWabgeschlossen = 805290007,
}

export enum FormularTyp {
    A_einfach = 805290000,
    B_mit_Finanzierungsinformation = 805290001,
    C_einfach_mit_Antragsvorlage = 805290002,
    V_Vorarlberg = 805290003
}

export enum Finanzierungsart {
    Weitere_Fordergeber = 805290000,
    Eigenmittel = 805290001
}


// WEBPACK FOOTER //
// ./src/app/shared/enums.ts